module.exports = __webpack_public_path__ + "img/202402_06.8cc86545.jpg";